export type { ModalWindowProps } from './model.type';

export { ModalWindow as Modal } from './Modal';
